import React from "react"
import { Container, Stack, Button } from "@carrotfertility/carotene"
import { Body } from "components/views/atoms/Bodies"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import useCarrotPlan, { getCarrotPlanQueryKey } from "components/carrot-plans/hooks/useCarrotPlan"
import { CarrotPlan } from "types/carrotPlanTypes"
import { adminCarrotClient } from "utils/CarrotClient"
import { useHistory } from "react-router-dom"
import { Paths } from "utils/Paths"
import { useQueryClient } from "react-query"
import Locations from "components/views/home/navigation"

function carrotPlanIsStale(data: Pick<CarrotPlan, "createdAtUtc">): boolean {
  const createdDate = new Date(data?.createdAtUtc)
  createdDate.setMonth(createdDate.getMonth() + 3)
  const today = new Date()
  return createdDate <= today
}

function carrotPlanCompleted(data: Pick<CarrotPlan, "steps">): boolean {
  return Boolean(data?.steps?.every((step) => Boolean(step?.completedAtUtc)))
}

function getModuleCopy({ steps }: Pick<CarrotPlan, "steps">): string {
  if (carrotPlanCompleted({ steps })) {
    return "It looks like you completed everything in your plan. Update us about your journey so we can continue to support you."
  }
  return "It's been a while. Any questions? Has anything changed? Update us about your journey so we can offer the most up-to-date guidance."
}

export function CarrotPlansRefreshModule(): JSX.Element {
  const { data } = useCarrotPlan()
  const query = useQueryClient()
  const history = useHistory()

  if (!data?.journeyCompleteTimestampUtc && (carrotPlanCompleted(data) || carrotPlanIsStale(data))) {
    const bodyCopy = getModuleCopy(data)
    return (
      <Container stack="medium" width="100%" borderRadius="8px" padding="medium" background="lightBlue">
        <Stack spacing="small">
          <Body>{bodyCopy}</Body>
          <Button onClick={() => history.push(Paths.REFRESH_CARROT_PLAN)} variant="primary">
            Refresh Carrot Plan
          </Button>
          <ArrowLink
            onClickOnly
            onClick={async () => {
              await adminCarrotClient.carrotPlanJourneyCompleted()
              query.invalidateQueries(getCarrotPlanQueryKey())
              history.push(Locations.Home.JourneyCompleteNote)
            }}
          >{`My journey with Carrot is complete for now`}</ArrowLink>
        </Stack>
      </Container>
    )
  }

  return null
}
